
import React, {Component} from 'react';
import ReactDOM, {render} from 'react-dom';
import url from 'c-url';
import lang from '../lang/index';
import native from 'c-up-native';
import BankNotice from '../popup/dialog-notice';

class BankSuccess extends Component {
    static defaultPorps = {
        orderData:{}
    }
    componentWillMount() {
        document.title = lang.template('支付结果')
    }

    back() {
        location.reload();

        //let backurl = url.query('backurl');

    }
    componentDidMount(){
        
        let minHeight = document.documentElement.clientHeight;
        $('.bankresult').css({
            minHeight: minHeight
        });
    }
    popUpNotice = ()=>{

        BankNotice.create();
    }
    
    render() {
        let orderData =  this.props.orderData;

        return (
            <div className="bankresult">
                <h2>{lang.template('汇款账户信息')}</h2>
                <div className="content">
                    <h3>{status}</h3>
                    <div className="bank-info">
                        <ul>
                            <li>
                                <label>{lang.template('银行代码')}</label>
                                <span className="info">807</span>
                            </li>
                            <li>
                                <label>{lang.template('银行名称')}</label>
                                <span className="info">{orderData.orderBank}</span>
                            </li>
                            <li>
                                <label>{lang.template('户名')}</label>
                                <span className="info">{lang.template('網易收服務ATM專戶')}</span>
                            </li>
                            <li>
                                <label>{lang.template('汇款账户')}</label>
                                <span className="info">{orderData.accountId}</span>
                            </li>
                            <li>
                                <label>{lang.template('汇款金额')}</label>
                                <span className="info">{orderData.moneySymbol}{orderData.money}</span>
                            </li>
                        </ul>
                    </div>
                    <div className="notice">{lang.template('请您于24小时内通过线下银行汇款的方式转账至上述银行账户，逾期将无法付款成功')}</div>
                </div>

                <div className="btn" onClick={this.back}>{lang.template('确定')}</div>
                <p className="notice-title" onClick={this.popUpNotice}>{lang.template('汇款注意事项')}</p>
            </div>
        );
    }
}

export default BankSuccess;




// WEBPACK FOOTER //
// ./js/result/bank-success.js